export type NameOptions =
	| undefined
	| { atomName: string }
	| { createAtomName: () => string }
	| {
			parentAtomName: string;
			childIndex?: string;
			createAtomName: (parentAtomName: string, childIndex?: string) => string;
	  };

let reactiveObjectId = 1;

export const createAtomName = () => {
	return `ReactiveObject@${reactiveObjectId++}`;
};

export const createRemoteAtomName = (atomName: string) => {
	return `Remote${createAtomName()}@${atomName}`;
};

export const createAtomNameFromOptions = (options: NameOptions) => {
	if (!options) {
		return createAtomName();
	}
	if ("atomName" in options) {
		return options.atomName;
	}
	if (!("parentAtomName" in options)) {
		return options.createAtomName();
	}
	return options.createAtomName(options.parentAtomName, options.childIndex);
};

export const createArrayAtomName = (parentAtomName: string) => {
	return `${parentAtomName}.Array`;
};

export const createArrayItemAtomName = (
	parentAtomName: string,
	childIndex?: string
) => {
	return `${parentAtomName}[${childIndex ?? createAtomName()}]`;
};

export const createMapValueAtomName = (
	parentAtomName: string,
	childIndex?: string
) => {
	return `${parentAtomName}.Value@${childIndex ?? createAtomName()}`;
};

export const createMapKeyAtomName = (
	parentAtomName: string,
	childIndex?: string
) => {
	return `${parentAtomName}.Key@${childIndex ?? createAtomName()})`;
};

export const createMapItemAtomName = (
	parentAtomName: string,
	childIndex?: string
) => {
	return `${parentAtomName}.key(${childIndex ?? createAtomName()})`;
};

export const createMapSizeAtomName = (parentAtomName: string) => {
	return `${parentAtomName}.size`;
};

export const createSetValueAtomName = (
	parentAtomName: string,
	childIndex?: string
) => {
	return `${parentAtomName}.Value@${childIndex ?? createAtomName()}`;
};

export const createSetTransformedAtomName = (
	parentAtomName: string,
	childIndex?: string
) => {
	return `${parentAtomName}.Transformed@${childIndex ?? createAtomName()}`;
};

export const createSetAtomName = (parentAtomName: string) => {
	return `${parentAtomName}.Set`;
};

export const createObjectKeysAtomName = (parentAtomName: string) => {
	return `${parentAtomName}.keys`;
};

export const createObjectComputedValueAtomName = (
	parentAtomName: string,
	childIndex?: string
) => {
	return `${parentAtomName}.${childIndex ?? createAtomName()}.Computed`;
};

export const createObjectValueAtomName = (
	parentAtomName: string,
	childIndex?: string
) => {
	return `${parentAtomName}.${childIndex ?? createAtomName()}`;
};

export const createPromiseAtomName = (parentAtomName: string) => {
	return `${parentAtomName}.Promise`;
};
